<geaui-page-layout-v3
  [headerTemplate]="header"
  [contentTemplate]="content"
  [sidebarTemplate]="sidebar"
>
  <ng-template #header>
    @if (noAuth !== undefined) {
      <geaui-header
        [noAuth]="noAuth"
        [showBanner]="false"
        [disableSignupMobile]="true"
        [disableLoginMobile]="true"
        [headerTitle]="$any(headerTitle$ | async)"
        [shoppingCartBadge]="$any(cartItems$ | async)"
        shoppingCartUrl="cart"
      >
      </geaui-header>
    }
  </ng-template>
  <ng-template #content>
    <div class="content-body">
      <router-outlet></router-outlet>
      <cx-page-slot position="Footer"></cx-page-slot>
    </div>
  </ng-template>
  <ng-template #sidebar>
    @if (!noAuth && tokenReady) {
      <!-- <CHANGE ME> - Change to Icon of your Choice -->
      <geaui-sidebar-v3
        [navigationItems]="$any(navEntries$ | async)"
        [slimView]="true"
        [adminViewNavigationItems]="adminNavItems"
        [bottomNavigation]="botItems"
        [devisionName]="$any(headerTitle$ | async)"
        devisionIconPath="https://content.apps.tst.gea.com/strg-container-apps/core/sapcommerce/icons/sapcommerce.svg"
        devisionIconBackgroundColor="var(--geaui-night-blue)"
      >
      </geaui-sidebar-v3>
    }
  </ng-template>
</geaui-page-layout-v3>
